module.exports = __webpack_public_path__ + "img/logo-webvideo.6d514ef7.png";